import { render, staticRenderFns } from "./TheNavbarToolsPanelUsableArea.vue?vue&type=template&id=515b9bff&scoped=true&"
import script from "./TheNavbarToolsPanelUsableArea.vue?vue&type=script&lang=js&"
export * from "./TheNavbarToolsPanelUsableArea.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbarToolsPanelUsableArea.vue?vue&type=style&index=0&id=515b9bff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515b9bff",
  null
  
)

export default component.exports